import logo01 from '../_assets/images/logo01.png';

export const ASSETS_IMG = {
  logo01,
};
